import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CollaboratorsDetailsComponent } from './collaborators-details.component';
const routes: Routes = [
  {
    path: '',
    component: CollaboratorsDetailsComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class collaboratorsDetailsRoutingoModule { }